const LayoutDefault = () => import('@/layout/Default');

export default {
  path: '/',
  component: LayoutDefault,
};
